'use strict';

export default class dateFormat {
    static twoDigit(num){
        if(Number.isNaN(num)){
            throw new Error('Not a number');
        }
        return `${Math.floor(num/10)%10}${num%10}`;
    }

    static getHMS(progress){
        const sec = this.twoDigit(Math.floor(progress / 1000) % 60);
        const min = this.twoDigit(Math.floor(progress / (1000 * 60)) % 60);
        const h = this.twoDigit(Math.floor(progress / (1000 * 60 * 60)) % 24);
        return `${h}:${min}:${sec}`;
    }

    static getHM(progress){
        const min = this.twoDigit(Math.floor(progress / (1000 * 60)) % 60);
        const h = this.twoDigit(Math.floor(progress / (1000 * 60 * 60)) % 24);
        return `${h}:${min}`;
    }
}
